import { render, staticRenderFns } from "./IntroductionNew.vue?vue&type=template&id=035b936e&scoped=true&"
import script from "./IntroductionNew.vue?vue&type=script&lang=js&"
export * from "./IntroductionNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035b936e",
  null
  
)

export default component.exports